import { EBuildingStatus, ECategoryType, ERoomType, IJsonQuery } from '@cian/api-models/common/json_query';
import { FOfferType } from '../../../../utils/offer_type';
import { FDealType, getDealType } from './getDealType';

export enum EObjectType {
  House = 1,
  Housepart = 2,
  Land = 3,
  Townhouse = 4,
}

export enum EOfficeType {
  Office = 1,
  TradeArea = 2,
  Warehouse = 3,
  PublicCatering = 4,
  FreeAppointmentObject = 5,
  Garage = 6,
  Manufacture = 7,
  AutoService = 9,
  Business = 10,
  Building = 11,
  DomesticServices = 12,
}

export function getOfferType(jsonQuery?: IJsonQuery | null): FOfferType {
  if (!jsonQuery) {
    return FOfferType.Unexpected;
  }

  const type = jsonQuery._type;
  const room = jsonQuery.room && jsonQuery.room.value;
  const buildingStatus = jsonQuery.building_status && jsonQuery.building_status.value;
  const fromDeveloper = jsonQuery.from_developer && jsonQuery.from_developer.value;
  const withNewBuildings = jsonQuery.with_newobject && jsonQuery.with_newobject.value;
  const dealType = getDealType(jsonQuery);

  if (type.startsWith('flat')) {
    if (room) {
      if (room.includes(ERoomType.FlatShared)) {
        return FOfferType.FlatShared;
      } else if (room.includes(ERoomType.Room)) {
        return FOfferType.Room;
      } else if (room.includes(ERoomType.Bed)) {
        return FOfferType.Bed;
      }
    }

    if (buildingStatus && buildingStatus === EBuildingStatus.New) {
      return FOfferType.FlatNew;
    }

    if (fromDeveloper !== undefined) {
      return FOfferType.FlatNew;
    }

    if (withNewBuildings) {
      return FOfferType.FlatNew;
    }

    if (buildingStatus && buildingStatus === EBuildingStatus.Old) {
      return FOfferType.FlatOld;
    }

    if (withNewBuildings !== undefined) {
      return FOfferType.FlatOld;
    }

    if (dealType & FDealType.Rent) {
      return FOfferType.FlatOld;
    }

    if (type === 'flatsale') {
      return FOfferType.Flat;
    }

    return FOfferType.Urban;
  }

  if (type.startsWith('suburban')) {
    const objectType = jsonQuery.object_type && jsonQuery.object_type.value;

    if (objectType) {
      if (objectType.includes(EObjectType.House)) {
        return FOfferType.House;
      } else if (objectType.includes(EObjectType.Housepart)) {
        return FOfferType.HousePart;
      } else if (objectType.includes(EObjectType.Townhouse)) {
        return FOfferType.Townhouse;
      }
    }

    if (objectType && objectType.includes(EObjectType.Land)) {
      if ((dealType & FDealType.Rent) === 0) {
        return FOfferType.Land;
      } else {
        return FOfferType.CommercialLand;
      }
    }

    return FOfferType.Suburban;
  }

  if (type.startsWith('commercial')) {
    const officeType = jsonQuery.office_type && jsonQuery.office_type.value;
    const category = jsonQuery.category && jsonQuery.category.value[0];

    if (officeType) {
      let offerType = FOfferType.Unexpected;
      if (officeType.includes(EOfficeType.Office)) {
        offerType |= FOfferType.Office;
      }

      if (officeType.includes(EOfficeType.TradeArea)) {
        offerType |= FOfferType.TradeArea;
      }

      if (officeType.includes(EOfficeType.Warehouse)) {
        offerType |= FOfferType.Warehouse;
      }

      if (officeType.includes(EOfficeType.FreeAppointmentObject)) {
        offerType |= FOfferType.FreeAppointmentObject;
      }

      if (officeType.includes(EOfficeType.PublicCatering)) {
        offerType |= FOfferType.PublicCatering;
      }

      if (officeType.includes(EOfficeType.Garage)) {
        offerType |= FOfferType.Garage;
      }

      if (officeType.includes(EOfficeType.Manufacture)) {
        offerType |= FOfferType.Manufacture;
      }

      if (officeType.includes(EOfficeType.AutoService)) {
        offerType |= FOfferType.AutoService;
      }

      if (officeType.includes(EOfficeType.Business)) {
        offerType |= FOfferType.Business;
      }

      if (officeType.includes(EOfficeType.Building)) {
        offerType |= FOfferType.Building;
      }

      if (officeType.includes(EOfficeType.DomesticServices)) {
        offerType |= FOfferType.DomesticServices;
      }

      return offerType;
    }

    if (category && [ECategoryType.CommercialLandRent, ECategoryType.CommercialLandSale].includes(category)) {
      return FOfferType.CommercialLand;
    }

    return FOfferType.Commercial;
  }

  return FOfferType.Unexpected;
}
